/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function getLineDetailsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getLineDetailsInput(customer: string, cartLineProduct: DataServiceEntities.ICartLineProductEntity): IDataServiceRequest {
    const query = getLineDetailsQuery();
    return query.createDataServiceRequestForOperation(
        'GetLineDetails',
        true,
        DataServiceEntities.CartLineProductEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICartLineProductEntity' },
        {
            customer: customer,
            cartLineProduct: cartLineProduct
        }
    );
}

export function getLineDetailsAsync(
    context: IContext,
    customer: string,
    cartLineProduct: DataServiceEntities.ICartLineProductEntity
): AsyncResult<DataServiceEntities.ICartLineProductEntity> {
    const request = getLineDetailsInput(customer, cartLineProduct);
    return callActionOrExecute<DataServiceEntities.ICartLineProductEntity>(request, context.callerContext);
}

function getCartWeightQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCartWeightInput(customer: string, cartLineProducts: DataServiceEntities.ICartLineProductEntity[]): IDataServiceRequest {
    const query = getCartWeightQuery();
    return query.createDataServiceRequestForOperation(
        'GetCartWeight',
        true,
        DataServiceEntities.CartDetailEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICartDetailEntity' },
        {
            customer: customer,
            cartLineProducts: cartLineProducts
        }
    );
}

export function getCartWeightAsync(
    context: IContext,
    customer: string,
    cartLineProducts: DataServiceEntities.ICartLineProductEntity[]
): AsyncResult<DataServiceEntities.ICartDetailEntity> {
    const request = getCartWeightInput(customer, cartLineProducts);
    return callActionOrExecute<DataServiceEntities.ICartDetailEntity>(request, context.callerContext);
}

function getVariantPriceQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getVariantPriceInput(customer: string, cartLines: DataServiceEntities.ICartLineEntity[]): IDataServiceRequest {
    const query = getVariantPriceQuery();
    return query.createDataServiceRequestForOperation(
        'GetVariantPrice',
        true,
        DataServiceEntities.CalculateCartPriceResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICalculateCartPriceResponse' },
        {
            customer: customer,
            cartLines: cartLines
        }
    );
}

export function getVariantPriceAsync(
    context: IContext,
    customer: string,
    cartLines: DataServiceEntities.ICartLineEntity[]
): AsyncResult<DataServiceEntities.ICalculateCartPriceResponse> {
    const request = getVariantPriceInput(customer, cartLines);
    return callActionOrExecute<DataServiceEntities.ICalculateCartPriceResponse>(request, context.callerContext);
}

function getInvoiceQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getInvoiceInput(invoiceId: string, customerAccount: string): IDataServiceRequest {
    const query = getInvoiceQuery();
    return query.createDataServiceRequestForOperation(
        'GetInvoice',
        true,
        DataServiceEntities.DocumentDataEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IDocumentDataEntity' },
        {
            invoiceId: invoiceId,
            customerAccount: customerAccount
        }
    );
}

export function getInvoiceAsync(
    context: IContext,
    invoiceId: string,
    customerAccount: string
): AsyncResult<DataServiceEntities.IDocumentDataEntity> {
    const request = getInvoiceInput(invoiceId, customerAccount);
    return callActionOrExecute<DataServiceEntities.IDocumentDataEntity>(request, context.callerContext);
}

function simplePingPostQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function simplePingPostInput(): IDataServiceRequest {
    const query = simplePingPostQuery();
    return query.createDataServiceRequestForOperation('SimplePingPost', true, '', 'false', { bypassCache: 'get', returnEntity: '' }, {});
}

export function simplePingPostAsync(context: IContext): AsyncResult<boolean> {
    const request = simplePingPostInput();
    return callActionOrExecute<boolean>(request, context.callerContext);
}

function getCachedDataQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCachedDataInput(searchCriteria: Entities.ProductSearchCriteria): IDataServiceRequest {
    const query = getCachedDataQuery();
    return query.createDataServiceRequestForOperation(
        'GetCachedData',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            searchCriteria: searchCriteria
        }
    );
}

export function getCachedDataAsync(context: IContext, searchCriteria: Entities.ProductSearchCriteria): AsyncResult<string> {
    const request = getCachedDataInput(searchCriteria);
    return callActionOrExecute<string>(request, context.callerContext);
}

function getOrganizationAccountQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getOrganizationAccountInput(customerAccount: string): IDataServiceRequest {
    const query = getOrganizationAccountQuery();
    return query.createDataServiceRequestForOperation(
        'GetOrganizationAccount',
        true,
        DataServiceEntities.OrgAccountEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IOrgAccountEntity' },
        {
            customerAccount: customerAccount
        }
    );
}

export function getOrganizationAccountAsync(
    context: IContext,
    customerAccount: string
): AsyncResult<DataServiceEntities.IOrgAccountEntity> {
    const request = getOrganizationAccountInput(customerAccount);
    return callActionOrExecute<DataServiceEntities.IOrgAccountEntity>(request, context.callerContext);
}

function simplePingGetQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function simplePingGetInput(): IDataServiceRequest {
    const query = simplePingGetQuery();
    return query.createDataServiceRequestForOperation('SimplePingGet', false, '', 'false', { bypassCache: 'get', returnEntity: '' }, {});
}

export function simplePingGetAsync(context: IContext): AsyncResult<boolean> {
    const request = simplePingGetInput();
    return callActionOrExecute<boolean>(request, context.callerContext);
}

// @ts-ignore
function allowedDaysByZipControllerQuery(rECID?: number): DataServiceQuery {
    const key = rECID ? { RECID: rECID } : null;
    return new DataServiceQuery(
        'AllowedDaysByZipController',
        'PromiseDateEntity',
        DataServiceEntities.PromiseDateEntityExtensionClass,
        key
    );
}

export function createGetAllowedDatesInput(zipCode: string, route: string): IDataServiceRequest {
    const query = allowedDaysByZipControllerQuery();
    return query.createDataServiceRequestForOperation(
        'GetAllowedDates',
        false,
        DataServiceEntities.PromiseDateEntityExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IPromiseDateEntity' },
        { zipCode: zipCode, route: route }
    );
}

export function getAllowedDatesAsync(
    context: IContext,
    zipCode: string,
    route: string
): AsyncResult<DataServiceEntities.IPromiseDateEntity> {
    const request = createGetAllowedDatesInput(zipCode, route);
    return callActionOrExecute<DataServiceEntities.IPromiseDateEntity>(request, context.callerContext);
}

export function createGetAllAllowedDatesInput(
    queryResultSettings: IQueryResultSettings,
    zipCode: string,
    route: string
): IDataServiceRequest {
    const query = allowedDaysByZipControllerQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllAllowedDates',
        false,
        DataServiceEntities.PromiseDateEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IPromiseDateEntity' },
        { zipCode: zipCode, route: route }
    );
}

export function getAllAllowedDatesAsync(
    context: IContext,
    zipCode: string,
    route: string
): AsyncResult<DataServiceEntities.IPromiseDateEntity[]> {
    const request = createGetAllAllowedDatesInput(context.queryResultSettings || {}, zipCode, route);
    return callActionOrExecute<DataServiceEntities.IPromiseDateEntity[]>(request, context.callerContext);
}

export function createCheckTableExistsInput(schemaName: string, tableName: string): IDataServiceRequest {
    const query = allowedDaysByZipControllerQuery();
    return query.createDataServiceRequestForOperation(
        'CheckTableExists',
        false,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { schemaName: schemaName, tableName: tableName }
    );
}

export function checkTableExistsAsync(context: IContext, schemaName: string, tableName: string): AsyncResult<boolean> {
    const request = createCheckTableExistsInput(schemaName, tableName);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

// @ts-ignore
function boundControllerQuery(unusualEntityId?: number): DataServiceQuery {
    const key = unusualEntityId ? { UnusualEntityId: unusualEntityId } : null;
    return new DataServiceQuery('BoundController', 'ExampleEntity', DataServiceEntities.ExampleEntityExtensionClass, key);
}

export function createCreateExampleEntityInput(entityData: DataServiceEntities.IExampleEntity): IDataServiceRequest {
    const query = boundControllerQuery();
    return query.createDataServiceRequestForOperation(
        'CreateExampleEntity',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { entityData: entityData }
    );
}

export function createExampleEntityAsync(context: IContext, entityData: DataServiceEntities.IExampleEntity): AsyncResult<number> {
    const request = createCreateExampleEntityInput(entityData);
    return callActionOrExecute<number>(request, context.callerContext);
}

export function createUpdateExampleEntityInput(
    unusualEntityId: number,
    updatedEntity: DataServiceEntities.IExampleEntity
): IDataServiceRequest {
    const query = boundControllerQuery(unusualEntityId);
    return query.createDataServiceRequestForOperation(
        'UpdateExampleEntity',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { updatedEntity: updatedEntity }
    );
}

export function updateExampleEntityAsync(
    context: IContext,
    unusualEntityId: number,
    updatedEntity: DataServiceEntities.IExampleEntity
): AsyncResult<boolean> {
    const request = createUpdateExampleEntityInput(unusualEntityId, updatedEntity);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

export function createDeleteExampleEntityInput(unusualEntityId: number): IDataServiceRequest {
    const query = boundControllerQuery(unusualEntityId);
    return query.createDataServiceRequestForOperation(
        'DeleteExampleEntity',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {}
    );
}

export function deleteExampleEntityAsync(context: IContext, unusualEntityId: number): AsyncResult<boolean> {
    const request = createDeleteExampleEntityInput(unusualEntityId);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

export function createGetAllExampleEntitiesInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = boundControllerQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllExampleEntities',
        false,
        DataServiceEntities.ExampleEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IExampleEntity' },
        {}
    );
}

export function getAllExampleEntitiesAsync(context: IContext): AsyncResult<DataServiceEntities.IExampleEntity[]> {
    const request = createGetAllExampleEntitiesInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IExampleEntity[]>(request, context.callerContext);
}
